export default __webpack_public_path__ + "static/media/chatBg.bafe88f8.png";